var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { EventEmitter } from '@angular/core';
import { Headers } from '@angular/http';
import { Http } from '@angular/http';
import { RequestMethod } from '@angular/http';
import { Response } from '@angular/http';
import { ResponseOptions } from '@angular/http';
import { URLSearchParams } from '@angular/http';
import { throwError, Observable, of } from 'rxjs';
import { camelCaseObject, snakeCase } from './case-transform';
import { LocalStorageService } from 'app/services/storage/local-storage.service';
import { PostMessageService } from 'app/services/post-message.service';
import { catchError, flatMap, map, tap } from 'rxjs/operators';
var CLIENT_BASIC = 'Basic NTRiYzEzM2E4ZTVmMmVkZTAwYzcwNTY5OmMwOGpObXhZYkZwUE5GSmFmV3hVY1hWdFduST0=';
var FORM_CONTENT_TYPE = 'application/x-www-form-urlencoded';
var WEB_API_URL = '/web-api';
var OAUTH_URL = WEB_API_URL + "/v0/token";
var LOCKED_KEY = 'locked';
var OAUTH_KEY = 'oauth';
var SIXTY_SECONDS = 60000;
function camelCaseResponse(response) {
    try {
        return camelCaseObject(response.json());
    }
    catch (e) {
        return response.text();
    }
}
function camelCaseError(response) {
    return new Response(new ResponseOptions({
        body: camelCaseResponse(response),
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        type: response.type,
        url: response.url
    }));
}
function mergeRequestOptions(body, options) {
    return Object.assign({ body: body }, options || {});
}
var ɵ0 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = Math.random() * 16 | 0, 
        // tslint:disable-next-line:no-bitwise
        v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
var UID = (ɵ0)();
var WebApi = /** @class */ (function () {
    function WebApi(_http, _localStorageService, _postMessageService) {
        var _this = this;
        this._http = _http;
        this._localStorageService = _localStorageService;
        this._postMessageService = _postMessageService;
        this.events = new EventEmitter();
        this._oauth = this._localStorageService.getJson(OAUTH_KEY);
        if (this.constructor.name === 'WebApi') {
            // от WebApi наследуется Api и поэтому раньше было дублирование вызовов
            this._unlockHttpQueue();
            setInterval(function () { return _this._prolongSession(); }, SIXTY_SECONDS);
            window.addEventListener('pagehide', function () {
                if (_this._isMyLockHttpQueue()) {
                    _this._unlockHttpQueue();
                }
                return '';
            }, { capture: true });
        }
        this._localStorageService.changeKey.subscribe(function (data) {
            if (data.key === OAUTH_KEY) {
                _this._oauth = _this._localStorageService.getJson(OAUTH_KEY);
                if (!_this._oauth) {
                    _this.events.emit('logout');
                }
            }
        });
    }
    /** Возвращает url запроса к web-api */
    WebApi.url = function (url) {
        return "" + WEB_API_URL + url;
    };
    /** Выполняет get запрос */
    WebApi.prototype.get = function (url, options) {
        return this._request(url, RequestMethod.Get, options);
    };
    /** Выполняет post запрос */
    WebApi.prototype.post = function (url, body, options) {
        return this._request(url, RequestMethod.Post, mergeRequestOptions(body, options));
    };
    /** Выполняет put запрос */
    WebApi.prototype.put = function (url, body, options) {
        return this._request(url, RequestMethod.Put, mergeRequestOptions(body, options));
    };
    /** Выполняет delete запрос */
    WebApi.prototype.delete = function (url, options) {
        return this._request(url, RequestMethod.Delete, options);
    };
    WebApi.prototype.getOnce = function (url, options) {
        return this._requestOnce(url, RequestMethod.Get, options);
    };
    WebApi.prototype._requestOnce = function (url, method, options) {
        options = this._createRequestOptions(url, method, options);
        return this._http.request(options.url, options).pipe(map(function (response) { return camelCaseResponse(response); }), catchError(function (response) { return throwError(camelCaseError(response)); }));
    };
    WebApi.prototype._request = function (url, method, options) {
        var _this = this;
        return this._waitUnlockHttpQueue().pipe(flatMap(function () {
            options = _this._createRequestOptions(url, method, options);
            return _this._http.request(options.url, options);
        }), map(function (response) {
            return camelCaseResponse(response);
        }), catchError(function (response) {
            if (response.status === 401) {
                var authHeader = _this.getAuthorizationHeader();
                if (options.headers.get('Authorization') !== authHeader ||
                    _this._isLockedHttpQueue()) {
                    options.headers.delete('Authorization');
                    return _this._waitUnlockHttpQueue().pipe(flatMap(function () { return _this._requestOnce(url, method, options); }));
                }
                return _this._restoreSessionWithLock().pipe(flatMap(function () {
                    options.headers.delete('Authorization');
                    return _this._requestOnce(url, method, options);
                }));
            }
            return throwError(camelCaseError(response));
        }));
    };
    WebApi.prototype.login = function (email, password) {
        var _this = this;
        var params = new URLSearchParams();
        params.append('grant_type', 'password');
        params.append('username', email);
        params.append('password', password);
        return this._oauthRequest(params).pipe(tap(function () { return _this.events.emit('login'); }));
    };
    WebApi.prototype.logout = function () {
        this._localStorageService.remove(OAUTH_KEY);
        this.events.emit('logout');
        return of(null);
    };
    WebApi.prototype.register = function (user) {
        var _this = this;
        var e_1, _a;
        var params = new URLSearchParams();
        params.append('grant_type', 'sign_up');
        try {
            for (var _b = __values(Object.keys(user)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                params.append(snakeCase(key), user[key]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this._oauthRequest(params).pipe(tap(function () { return _this.events.emit('register'); }));
    };
    WebApi.prototype.recoverPassword = function (email, resetPasswordUrl) {
        var _this = this;
        var params = new URLSearchParams();
        params.append('grant_type', 'client_credentials');
        return this._oauthRequest(params).pipe(flatMap(function () {
            return _this.post('/v0/user/password/request', {
                email: email,
                reset_password_url: resetPasswordUrl
            });
        }));
    };
    WebApi.prototype.changePassword = function (password, token) {
        var _this = this;
        var params = new URLSearchParams();
        params.append('grant_type', 'client_credentials');
        return this._oauthRequest(params).pipe(flatMap(function () {
            return _this.post('/v0/user/password/commit', {
                password: password,
                token: token
            });
        }));
    };
    WebApi.prototype._prolongSession = function () {
        if (this._oauth && !this._isLockedHttpQueue()) {
            var _a = this._oauth, accessToken = _a.accessToken, created = _a.created, expiresIn = _a.expiresIn;
            var expires = created + (expiresIn - 3 * SIXTY_SECONDS);
            if (expires < Date.now()) {
                if (accessToken !== this._oauth.accessToken) {
                    return;
                }
                this._restoreSessionWithLock().subscribe();
            }
        }
    };
    WebApi.prototype._oauthRequest = function (params) {
        var _this = this;
        var headers = new Headers({
            Authorization: CLIENT_BASIC,
            'Content-Type': FORM_CONTENT_TYPE
        });
        return this._http.post(OAUTH_URL, params.toString(), { headers: headers }).pipe(map(function (response) { return camelCaseResponse(response); }), map(function (oauth) { return _this._setOAuth(oauth); }), catchError(function (response) { return throwError(camelCaseError(response)); }));
    };
    WebApi.prototype._setOAuth = function (response) {
        this._oauth = {
            accessToken: response.accessToken,
            refreshToken: response.refreshToken,
            tokenType: response.tokenType,
            expiresIn: 1000 * response.expiresIn,
            created: Date.now()
        };
        this._localStorageService.setJson(OAUTH_KEY, this._oauth);
    };
    WebApi.prototype._getUrl = function (url) {
        return WebApi.url(url);
    };
    WebApi.prototype._createRequestOptions = function (url, method, options) {
        options = options || {};
        this._setAuthorizationHeader(options);
        options.method = method;
        options.url = this._getUrl(url);
        return options;
    };
    WebApi.prototype._setAuthorizationHeader = function (options) {
        var headers = options.headers || new Headers();
        if (!headers.has('Authorization')) {
            headers.set('Authorization', this.getAuthorizationHeader());
        }
        options.headers = headers;
        return options;
    };
    WebApi.prototype.getAuthorizationHeader = function () {
        return "Bearer " + (this._oauth && this._oauth.accessToken);
    };
    WebApi.prototype._restoreSessionWithLock = function () {
        var _this = this;
        if (this._isLockedHttpQueue()) {
            return this._waitUnlockHttpQueue();
        }
        this._lockHttpQueue();
        return Observable.create(function (observer) {
            setTimeout(function () {
                if (!_this._isMyLockHttpQueue()) {
                    return _this._waitUnlockHttpQueue().subscribe(function () {
                        observer.next();
                        observer.complete();
                    });
                }
                _this._restoreSession().subscribe(function () {
                    observer.next();
                    observer.complete();
                });
            }, 100);
        });
    };
    WebApi.prototype._restoreSession = function () {
        var _this = this;
        // несмотря на то, что есть changeKey для OAUTH_KEY,
        // иногда сюда попадает раньше чем срабатывает changeKey
        this._oauth = this._localStorageService.getJson(OAUTH_KEY);
        if (this._oauth && this._oauth.refreshToken) {
            var params = new URLSearchParams();
            params.append('grant_type', 'refresh_token');
            params.append('refresh_token', this._oauth.refreshToken);
            return this._oauthRequest(params).pipe(tap(function () {
                _this._unlockHttpQueue();
                _this.events.emit('restore');
            }), catchError(function (error) {
                _this._unlockHttpQueue();
                _this._localStorageService.remove(OAUTH_KEY);
                return throwError(error);
            }));
        }
        else {
            return Observable.create(function (observer) {
                var postMessageRefresh = function (message) {
                    _this._unlockHttpQueue();
                    if (message && message.action === 'accessTokenUpdated') {
                        _this._postMessageService.off(postMessageRefresh);
                        _this._setOAuth({ accessToken: message.accessToken });
                        observer.next();
                        observer.complete();
                        _this.events.emit('restore');
                    }
                };
                _this._postMessageService.on(postMessageRefresh);
                PostMessageService.sendTo(window.parent, JSON.stringify({ action: 'accessTokenExpired' }));
            });
        }
    };
    WebApi.prototype._isLockedHttpQueue = function () {
        return !!this._localStorageService.get(LOCKED_KEY);
    };
    WebApi.prototype._lockHttpQueue = function () {
        this._localStorageService.set(LOCKED_KEY, UID);
    };
    WebApi.prototype._isMyLockHttpQueue = function () {
        return this._localStorageService.get(LOCKED_KEY) === UID;
    };
    WebApi.prototype._unlockHttpQueue = function () {
        this._localStorageService.remove(LOCKED_KEY);
    };
    WebApi.prototype._waitUnlockHttpQueue = function () {
        var _this = this;
        if (this._isLockedHttpQueue()) {
            return Observable.create(function (observer) {
                var unlockSubscription = _this._localStorageService.changeKey.subscribe(function (data) {
                    if (data.key === LOCKED_KEY && !data.value) {
                        unlockSubscription.unsubscribe();
                        observer.next(void 0);
                        observer.complete();
                    }
                });
            });
        }
        return of(null);
    };
    WebApi.prototype.setAuthToken = function (xhr) {
        xhr.setRequestHeader('Authorization', this.getAuthorizationHeader());
    };
    return WebApi;
}());
export { WebApi };
export { ɵ0 };
